import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try {
      fetch('https://api.forms.celto.dk/client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: error?.message,
          stack: error?.stack,
          componentStack: info?.componentStack,
          url: window.location.href,
          ua: navigator.userAgent,
        }),
      });
    } catch (_) {}
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh', background: '#F9F8F5',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '32px', fontFamily: 'sans-serif',
        }}>
          <div style={{ maxWidth: 480, textAlign: 'center' }}>
            <p style={{ fontSize: 18, marginBottom: 12 }}>
              Der opstod en uventet fejl.
            </p>
            <p style={{ color: '#888', marginBottom: 24 }}>
              Prøv at genindlæse siden. Hvis problemet fortsætter, kontakt venligst Celto.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#3F3F3F', color: '#fff', border: 'none',
                padding: '12px 28px', borderRadius: 8, fontSize: 15, cursor: 'pointer',
              }}
            >
              Genindlæs siden
            </button>
            <p style={{ color: '#bbb', fontSize: 12, marginTop: 20 }}>
              {this.state.error?.message}
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
